goog.provide("shadow.js.shim.module$src$svg$artwork$masonry_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$masonry_svg");
shadow.js.shim.module$src$svg$artwork$masonry_svg = shadow.js.nativeProvides["src/svg/artwork/masonry.svg"] = shadow$bridge("src/svg/artwork/masonry.svg");
module$shadow_js_shim_module$src$svg$artwork$masonry_svg.default = shadow.js.shim.module$src$svg$artwork$masonry_svg;
